"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Phone } from "lucide-react";
export default function ServicesHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section id="services-hero" className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/therapist_child_sunlit_room.png)] transform scale-105 transition-transform duration-[400ms] ease-smooth" style={{
      transform: typeof window !== "undefined" ? `translateY(${window.scrollY * 0.05}px) scale(1.05)` : "scale(1.05)"
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />

      {}
      <div ref={ref} className="relative z-10 max-w-5xl mx-auto px-6 lg:px-8 text-center">
        {}
        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
          <h1 className="text-white font-display font-bold text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight mb-3">
            Compassionate ABA Therapy Services
          </h1>
          <p className="text-white/95 font-display font-semibold text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight mb-6">
            Servicios de Terapia ABA con Compasión
          </p>
        </div>

        {}
        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
          <p className="text-white/90 text-lg md:text-xl lg:text-2xl font-sans max-w-3xl mx-auto mb-10">
            Evidence-based, family-centered support for children and adolescents with autism and developmental needs in Miami-Dade County.
          </p>
        </div>

        {}
        <div className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
          {}
          <Link to="/GetStartedPage">
            <Button size="lg" className="btn-primary text-lg px-10 py-4 h-auto shadow-medium hover:shadow-strong transition-all duration-[80ms] ease-[var(--ease-smooth)]">
              Request Services
            </Button>
          </Link>

          {}
          <Link to="tel:+13051234567">
            <Button size="lg" variant="outline" className="bg-white/10 backdrop-blur-sm text-white border-white/40 hover:bg-white/20 hover:border-white/60 text-lg px-10 py-4 h-auto shadow-medium hover:shadow-strong transition-all duration-[80ms] ease-[var(--ease-smooth)]">
              <Phone className="size-5" />
              Call Us
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}